module.exports = __webpack_public_path__ + "static/img/20230608_02.461b27f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20230608_02.png
// module id = sWGK
// module chunks = 0